import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=17192bd0&scoped=true"
import script from "./Topbar.js?vue&type=script&lang=js&external"
export * from "./Topbar.js?vue&type=script&lang=js&external"
import style0 from "./Topbar.scss?vue&type=style&index=0&id=17192bd0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17192bd0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
